// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__6u7Tq","btn_sm":"Button_btn_sm__uBuCD"};